import {
  DropdownMenuCheckboxItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

interface FieldVisibilitySectionProps {
  label: string;
  fieldNames: string[];
  idFor: (fieldName: string) => string;
  visibleFieldIds: string[];
  onToggle: (fieldId: string) => void;
}

/**
 * Renders one labeled group of field checkboxes in the "Field Visibility" menu.
 * Renders nothing when the group has no fields.
 */
export function FieldVisibilitySection({
  label,
  fieldNames,
  idFor,
  visibleFieldIds,
  onToggle,
}: FieldVisibilitySectionProps) {
  if (fieldNames.length === 0) {
    return null;
  }

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>{label}</DropdownMenuLabel>
      {fieldNames.map((fieldName) => {
        const fieldId = idFor(fieldName);
        return (
          <DropdownMenuCheckboxItem
            key={fieldId}
            checked={visibleFieldIds.includes(fieldId)}
            onCheckedChange={() => onToggle(fieldId)}
            onSelect={(e) => e.preventDefault()}
          >
            {fieldName}
          </DropdownMenuCheckboxItem>
        );
      })}
    </>
  );
}
